import React from 'react';
import { createRoot } from 'react-dom/client';
import YotpoReviewsSeoWidget from './yotpo-reviews-seo-widget';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(<YotpoReviewsSeoWidget {...data} />);
  };

  init();
};
